module.exports = __webpack_public_path__ + "assets/img/ab5-7.4d51e6da.png";